/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import $ from 'jquery';
import React from 'react';

import * as browser from 'lib/Browser';
import ProtocolActions from 'notebook/protocols/actions/ProtocolActions';
import ExtraInfo from 'notebook/protocols/ExtraInfo';
import * as ProtocolUtil from 'notebook/protocols/ProtocolUtil';
import ProtocolStore from 'notebook/protocols/stores/ProtocolStore';
// @ts-expect-error
import CommentBus from 'notebook/protocols/viewer/CommentBus';
import ProtocolNavigation from 'notebook/protocols/viewer/Navigation';
import PrintButton from 'notebook/protocols/viewer/PrintButton';
import Viewer from 'notebook/protocols/viewer/Viewer';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface Props {
  apiIdentifier: string;
  user?: any;
}

type State = any;

export default class ProtocolPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const {protocol} = ProtocolStore.getState();

    this.state = {
      protocol,
      commentBus: new CommentBus({
        user: props.user,
        protocol,
      }),
    };
  }

  stepByStepURL = (): string => `${this.state.protocol.url}/sbs`;

  componentDidMount(): void {
    if (browser.isBrowser) {
      $(window).on('resize.protocolpage', () => this.state.commentBus.reflow());
    }
    ProtocolActions.open(this.props.apiIdentifier);
    ProtocolStore.addChangeListener(this._protocolChangeHandler);
  }

  _protocolChangeHandler = (): void => {
    const {protocol} = ProtocolStore.getState();
    const protocolChanged =
      (this.state.protocol != null ? this.state.protocol.id : undefined) !==
      (protocol != null ? protocol.id : undefined);
    const commentBus = protocolChanged
      ? new CommentBus({
          user: this.props.user,
          protocol,
        })
      : this.state.commentBus;
    this.setState({protocol, commentBus});
  };

  componentWillUnmount(): void {
    ProtocolStore.removeChangeListener(this._protocolChangeHandler);
    if (browser.isBrowser) {
      $(window).off('.protocolpage');
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State): void {
    if (this.props.apiIdentifier !== prevProps.apiIdentifier) {
      ProtocolActions.open(this.props.apiIdentifier);
    }

    if (browser.isBrowser) {
      if (this.state.commentBus != null) {
        return this.state.commentBus.reflow();
      }
    }
  }

  render(): JSX.Element {
    const {protocol} = this.state;
    return (
      <div className="protocol-page">
        {(() => {
          if (protocol != null) {
            const sections = [
              {
                key: 'intro',
                icon: <BenchlingIcon icon="info-circle" />,
                tooltip: 'Introduction',
              },
              {
                key: 'materials',
                icon: <BenchlingIcon icon="flask" />,
                tooltip: 'Materials',
              },
              {
                key: 'procedure',
                icon: <BenchlingIcon icon="table-list" />,
                tooltip: 'Procedure',
              },
              {
                key: 'comments',
                icon: <BenchlingIcon icon="comment" />,
                tooltip: 'Comments',
              },
            ];
            return [
              <div className="container" key="header">
                <div className="protocol-header protocol-resize-container">
                  <div className="protocol-title">
                    <h1>{ProtocolUtil.displayName(protocol)}</h1>
                  </div>
                  <div className="btn-toolbar">
                    <div className="btn-group">
                      <PrintButton />
                    </div>
                  </div>
                </div>
                <div className="protocol-header-border" key="border" />
              </div>,
              <div className="container" key="body">
                <div className="protocol-resize-container">
                  <ProtocolNavigation sections={sections} stepByStepURL={this.stepByStepURL()} />
                  <ExtraInfo
                    creator={protocol.creator}
                    modifiedAt={protocol.modified_at}
                    owner={protocol.folder.owner}
                    stepByStepURL={this.stepByStepURL()}
                  />
                  <Viewer
                    commentBus={this.state.commentBus}
                    protocol={protocol}
                    sections={sections}
                    showTitle={false}
                    showFormulaBox={true}
                  />
                </div>
              </div>,
            ];
          }
          return null;
        })()}
      </div>
    );
  }
}
